import React, { useState } from "react";
import { Typography, Button, Grid, TextField, IconButton, InputAdornment, Snackbar, Alert, CircularProgress, Box } from "@mui/material";
import Layout from "./UserLayout";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { formFieldStyles, labelStyles } from "../../styles/formStyles";
import { getUserDetails, setNewPassword } from "../../services/User";
import { ILoginUserDetails, ISetPasswordDTO } from "../../interfaces/User";
import { useAuth } from "../../auth/AuthProvider";

const SetNewPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;
  const { login, setLoginUser} = useAuth();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: "",
  });
  const [msg, setMsg] = useState("");
  const [openError, setOpenError] = useState(false);
  const [openSuccess,setOpenSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const validate = (): boolean => {
    const newErrors = {
      password: "",
      confirmPassword: "",
    };
    let valid = true;

    if (!password) {
      newErrors.password = "Password is required";
      valid = false;
    } else if (password.length < 6) {
      newErrors.password = "Minimum 6 characters";
      valid = false;
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
      valid = false;
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      const dto = {}  as ISetPasswordDTO;
      dto.password = password;
      dto.confirmPassword = confirmPassword;
      const res = await setNewPassword(dto);
      console.log("Set new password response", res);
      if(res && res .status === "success"){
        const info = res.rawResponse?.data?.data;
        console.log("Set new password data", );
        setOpenSuccess(true);
        setMsg("Account created successfully!");

        if(info) {
          login(info.accessToken as string);
        
          const userDetailsRepsonse = await getUserDetails();
          console.log("User details response", userDetailsRepsonse);
          if (userDetailsRepsonse && userDetailsRepsonse.id) {
            setLoginUser(JSON.stringify(userDetailsRepsonse));
            //const user = userDetailsRepsonse as ILoginUserDetails;
            navigate("/onboarding");
            return;
          }
        } else {
          navigate("/login");
        }
      }
      else if(res && res.status === "error"){
        const errMsg = res.errorResponse?.response?.data.message || res.errorResponse?.message || "Failed to set password.";
        setMsg(errMsg);
        setOpenError(true);
      }  
    } catch {
      setMsg("Failed to set password");
      setOpenError(true);
    } finally {
      setLoading(false);
    }
  };
  const handleSnackbarClose = () => {
    setOpenError(false);
  };
  return (
    <Layout>
      <Typography variant="h5" mb={1.5}>
        Set your password
      </Typography>

      <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography component="label" sx={labelStyles}>
              Password <span style={{ color: "#FE0909" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              size="small"
              type={showPassword ? "text" : "password"}
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={!!errors.password}
              helperText={errors.password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      size="small"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={formFieldStyles}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography component="label" sx={labelStyles}>
              Confirm Password <span style={{ color: "#FE0909" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              size="small"
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      edge="end"
                      size="small"
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={formFieldStyles}
            />
          </Grid>

          <Grid item xs={12}>
            {!loading && (
            <Button
            onClick={handleSubmit}
            fullWidth
            sx={{
              borderRadius: "6px",
              background: "#005EFF",
              color: "#fff",
              fontWeight: 600,
              py: 1,
              textTransform: "none",
              "&:hover": {
                background: "#0047cc",
              },
            }}
            endIcon={<ArrowForwardIcon />}
          >
            Set Password
          </Button>
            )}
            {loading && (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress />
              </Box>
            )}
          </Grid>

          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate("/signup")}
              sx={{ textTransform: "none" }}
            >
              Back to Signup
            </Button>
          </Grid>
        </Grid>
      <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={openSuccess}
      autoHideDuration={5000}
      onClose={handleSnackbarClose}
    >
      <Alert severity="success" variant="filled" sx={{ width: "100%" }}>
        {msg}
      </Alert>
    </Snackbar>
      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={openError} autoHideDuration={5000} onClose={handleSnackbarClose}>
        <Alert severity="error" variant="filled" sx={{ width: "100%" }}>{msg}</Alert>
      </Snackbar>
    </Layout>
  );
};

export default SetNewPassword;
